import React from 'react';
import './InviteLimitBadge.css';

export interface InviteLimitBadgeProps {
  /** Number of remaining invites */
  remaining: number;
  /** Optional reset date (shown only when remaining is 0) */
  resetDate?: string;
  /** Type of invite for styling context (reserved for future styling) */
  type?: 'farmer' | 'employee';
  /** Optional class name */
  className?: string;
}

/**
 * Badge displaying remaining invite count with optional reset date.
 * Shows reset date only when no invites remain (for farmer type).
 */
export const InviteLimitBadge: React.FC<InviteLimitBadgeProps> = ({
  remaining,
  resetDate,
  type: _type = 'farmer',
  className = '',
}) => {
  const isExhausted = remaining <= 0;

  return (
    <span
      className={`invite-limit-badge ${isExhausted ? 'invite-limit-badge--exhausted' : ''} ${className}`}
    >
      {isExhausted && resetDate ? (
        <>
          <span className="invite-limit-badge__count">(0 left</span>
          <span className="invite-limit-badge__reset">, renew {resetDate})</span>
        </>
      ) : (
        <span className="invite-limit-badge__count">({remaining} left)</span>
      )}
    </span>
  );
};

export default InviteLimitBadge;
